import React, {Component} from 'react';
import moment from "moment";
import ClockIcon from "../../Common/components/svg/ClockIcon";
import AuthorAvatar from '../../Common/components/AuthorAvatar';
import PropTypes from 'prop-types';
import {getArticleReadTime} from "../utils";
import "./ArticleAuthor.scss";
import withErrorBoundary from "../../Errors/components/withErrorBoundry";

const ROOT_CLICK_EVENT_NAME = '[Articles]';

class ArticleAuthor extends Component {
    static contextTypes = {
        metrics: PropTypes.object
    }

    constructor(props) {
        super(props);

        this.onAvatarClick = this.onAvatarClick.bind(this);
        this.onNameClick = this.onNameClick.bind(this);
        this.onTypeClick = this.onTypeClick.bind(this);
    }

    onTrackClick(link) {
        if (!this.context.metrics || !this.context.metrics.track) {
            return;
        }

        this.context.metrics.track("linkClick", {link});
    }

    onAvatarClick() {
        this.onTrackClick(`${ROOT_CLICK_EVENT_NAME} Author Avatar Click`);
    }

    onNameClick() {
        this.onTrackClick(`${ROOT_CLICK_EVENT_NAME} Author Name Click`);
    }

    onTypeClick() {
        this.onTrackClick(`${ROOT_CLICK_EVENT_NAME} Author Type Click`);
    }    

    render() {
        const {article} = this.props;
        const { last_updated, author_profile } = article;

        const readTime = getArticleReadTime(article);

        return (
            <div className="article-author">
                {author_profile &&
                    <div className="article-author__avatar">
                        <AuthorAvatar onClick={this.onAvatarClick} image={author_profile.image_ref} />
                    </div>
                }
                <div className="article-author__right">
                    {author_profile &&
                        <div className="article-author__author-info">
                            <span onClick={this.onNameClick} className="author-name">{author_profile.name}</span> · <span onClick={this.onTypeClick} className="author-bio">{author_profile.type_name}</span>
                        </div>
                    }
                    <div className="article-author__last-updated">
                        <ClockIcon title="Last Updated"/><div>{moment.unix(last_updated/1000.0).format("HH:mm · MMMM DD, YYYY")} · <span className="readTime">{readTime} min read</span></div>
                    </div>
                </div>
            </div>
        );
    }

}

ArticleAuthor.propTypes = {
    article: PropTypes.object.isRequired
}


export default withErrorBoundary(ArticleAuthor);



// WEBPACK FOOTER //
// ./modules/News/components/ArticleAuthor.js